import { Deserializable } from '../deserializable';
import {Staffs} from '../staff/staffs';
import {IdentityItem} from './identityitem';


export  class LogAction implements Deserializable
{
  public id: number;
  public title: string;
  public className: string;
  public classPk: number;
  public classFk: number;
  public action: string;
  public userId: number;
  public staffId: number;
  public userName: string;
  public created: Date;
  public staffs: Staffs;
  public identityItem: IdentityItem;
  deserialize(input: any): this {
    Object.assign(this, input);
    this.identityItem = input.identityItem != null ?  new IdentityItem().deserialize(input.identityItem): null;
    this.staffs = input.staffs != null ?  new Staffs().deserialize(input.staffs): null;
    return this;
  }
}
